import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

export function useDeviceId() {
  const [deviceId, setDeviceId] = useState<string>("");

  useEffect(() => {
    let storedDeviceId = localStorage.getItem("deviceId") || uuidv4(); 
    if (!localStorage.getItem("deviceId")) {
      localStorage.setItem("deviceId", storedDeviceId);
    }
    setDeviceId(storedDeviceId);
  }, []);

  return deviceId;
}
